import { Component, Input } from '@angular/core';
import { OEP_ROLE_LABELS, type OEPRoleKey } from 'agu_oep_core';

/** Role chip — logic.js chip() geometry (999px, 3px 11px, 12px/700, .01em); colors from the --oep-role-* tokens. */
@Component({
    standalone: false,
    selector: 'oep-role-chip',
    template: `<span class="oep-chip" [attr.data-role]="Role">{{ Label }}</span>`,
    styleUrl: './oep-role-chip.component.scss',
})
export class OEPRoleChipComponent {
    @Input({ required: true }) Role!: OEPRoleKey;
    get Label(): string {
        return OEP_ROLE_LABELS[this.Role].Label;
    }
}
